
import { defineComponent } from 'vue'
import OrderDetail from './OrderDetail.vue'

export default defineComponent({
  name: 'DoctorOrders',
  // props: ['orders'],
  components : {
    OrderDetail
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        title: 'Date',
        align: 'start',
        sortable: false,
        key: 'date',
      },
      { title: 'Time', key: 'time' },
      { title: 'Visit', key: 'visitNumber'},
      { title: 'Type', key: 'type' , sortable: false },
      { title: 'Description', key: 'description', sortable: false  },
      { title: 'Actions', key: 'actions', sortable: false },
    ],
    orders: [],
    editedIndex: -1,
    editedItem: {
      date: '',
      time: '',
      visitNumber: '',
      type: '',
      description: ''
    },
    defaultItem: {
      date: '',
      time: '',
      visitNumber: '',
      type: '',
      description: ''
    },
  }),

  computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add New orders' : 'Edit orders'
      },
    },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    this.initialize()
  },
//   Lab, Radiology, Medication, Procedures
  methods: {
    initialize () {
      this.orders = [
        {
          date: '2023-04-01',
          time: '11:00',
          visitNumber: 'VHI-230508',
          type: 'Lab',
          description: 'Some Lab Order'
        },
        {
          date: '2023-04-01',
          time: '12:00',
          visitNumber: 'VHI-230508',
          type: 'Medication',
          description: 'Medication for headache'
        }      
      ]
    },

    editItem (item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.orders.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.orders[this.editedIndex], this.editedItem)
      } else {
        this.orders.push(this.editedItem)
      }
      this.close()
    },

    onUpdateOrder(value) {
      this.editedItem = value
    },
  },

})
